import {UbcLogger} from '@baidu/ubc-report-sdk';

const smartScriptId = 17667; // 一键装修商品点击、建议hover、素材上传、取消素材预览
const smartScriptModuleId = 17668; // 组件替换内容点击
const smartScriptTemplateId = 17669; // 模板点击
const smartScriptCreateId = 17671; // 编辑剧本点击
const smartScriptAiCreateId = 17672; // AI一键装修点击

const smartScriptLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: smartScriptId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const smartScriptModuleLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: smartScriptModuleId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const smartScriptTemplateLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: smartScriptTemplateId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const smartScriptCreateLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: smartScriptCreateId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const smartScriptAiCreateLogger = new UbcLogger({
    from: 'script',
    page: 'huibo',
    ev_l_t: 'click',
    serverId: smartScriptAiCreateId,
    queryParams: {
        appname: 'hui_bo_xing'
    }
});

const logMap = {
    smartScript: {
        logger: smartScriptLogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    smartScriptModule: {
        logger: smartScriptModuleLogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    smartScriptTemplate: {
        logger: smartScriptTemplateLogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    smartScriptCreate: {
        logger: smartScriptCreateLogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    },
    smartScriptAiCreate: {
        logger: smartScriptAiCreateLogger,
        commonParams: {
            from: 'script',
            ev_l_t: 'click',
            pos_id: '1662__',
            source: 'pc'
        }
    }
};

function log(type, params = {}, action = 'click') {
    try {
        const {value, extParam = {}} = params;
        const {logger, commonParams} = logMap[type];

        logger.send({
            ...commonParams,
            type: action,
            value,
            ext: extParam
        });

        // console.log('log =====>', type, {
        //     value,
        //     ext: extParam
        // });
    }
    catch (e) {
        // safe log
    }
}

export const smartScriptLog = (btn, ext) => {
    const valMap = {
        decorate_goods_click: 'decorate_goods_click',
        material_upload: 'material_upload',
        nopreview_click: 'nopreview_click',
        tips_show: 'tips_show'
    };
    log('smartScript', {
        value: valMap[btn],
        extParam: {
            ...ext
        }
    });
};

export const smartScriptModuleLog = (type) => {
    log('smartScriptModule', {
        value: 'com_click',
        extParam: {
            com_type: type
        }
    });
};

export const smartScriptTemplateLog = (ext) => {
    log('smartScriptTemplate', {
        value: 'template_click',
        extParam: {
            ...ext
        }
    });
};

export const smartScriptCreateLog = (ext) => {
    log('smartScriptCreate', {
        value: 'edit_click',
        extParam: {
            ...ext
        }
    });
};

export const smartScriptAiCreateLog = (ext) => {
    log('smartScriptAiCreate', {
        value: 'decorate_click',
        extParam: {
            ...ext
        }
    });
};